<template>
  <div class="msgDetails">
    <div class="zMsgSearch">
      <span>{{$t('common.dateRange')}}</span>
      <el-date-picker
        style="width: 360px"
        size="small"
        v-model="DataValue"
        type="datetimerange"
        :clearable="false"
        value-format="yyyy-MM-dd HH:mm:ss"
        :range-separator="$t('common.to')"
        :start-placeholder="$t('BatteryStatus.happenTime')"
        :end-placeholder="$t('BatteryStatus.endTime')"
      >
      </el-date-picker>
      <el-button
        style="margin-left: 18px"
        @click="onSearch"
        size="small"
        type="primary"
        class="btn-chaxun"
        >{{$t('common.btn.search')}}</el-button
      >
      <el-button @click="onClear" size="small" class="btn-del">{{$t('common.btn.cancel')}} </el-button>
      <span
        style="color: #409eff; display: inline-block; float: right"
        @click="down"
        >{{$t('common.btn.download')}}</span
      >
    </div>
    <div style="width: 100%; height: 100%">
      <div v-if="isValue" v-loading="speedLoading">
        <linegraph
          :id="'speedBargraph'"
          :data="speedOption"
          style="height: 400px"
        ></linegraph>
      </div>
      <div
        v-else
        style="
          color: #868686;
          font-size: 16px;
          text-align: center;
          line-height: 400px;
        "
      >
        {{$t('common.noData')}}
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import linegraph from "../../../../components/linegraph.vue";
import { domainName } from "../../../../utility/index";
import moment from "moment";

export default {
  props: ["bindBattery"],
  components: { linegraph },
  data() {
    return {
      DataValue: [],
      speedOption: {},
      speedLoading: false,
      isValue: true,
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    getDate() {
      const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      const startTime = moment().subtract(3, "days").format("YYYY-MM-DD HH:mm:ss");
      this.DataValue = [startTime, endTime];
    },
    changeTime() {
      this.getDayUseRate();
      this.getMonthOrderList("all");
    },
    getSpeedAndWeightHis() {
      this.speedLoading = true;
      let obj = {
        Data: [],
        power: [],
      };
      let param = {
        batteryNumber: this.bindBattery,
        startTime: this.DataValue[0],
        endTime: this.DataValue[1],
      };
      this.$store
        .dispatch("BatteryFile/GET_QUERYBATTERYPOWER", param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              if (res.data.data.length > 0) {
                this.isValue = true;
                res.data.data.map((item, index) => {
                  console.log(item);
                  obj.Data.push(item.time);
                  obj.power.push(item.value);
                  this.SpeedAndWeightHis(obj);
                });
              } else {
                this.isValue = false;
              }
            }
          }
          this.speedLoading = false;
        })
        .catch((err) => {
          this.speedLoading = false;
        });
    },
    SpeedAndWeightHis(obj) {
      let option = {
        legend: {
          left: "10",
          data: [this.$t('BatteryStatus.voltage')],
          left: "center",
          textStyle: {
            color: "#000",
          },
        },
        grid: {
          top: "15%",
          left: "6%",
          right: "1%",
          bottom: "70",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        dataZoom: [
          {
            type: "inside",
            textStyle: {
              color: "#000",
            },
          },
          {
            type: "slider",
            textStyle: {
              color: "#000",
            },
          },
        ],
        xAxis: {
          data: obj.Data,
          silent: false,
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#000", 
            },
          },
          axisLabel: {
            textStyle: {
              color: "#000", 
            },
          },
          splitArea: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "value",
            name: this.$t('BatteryStatus.voltage'),
            nameTextStyle: {
              color: "white",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["rgba(173,177,195,.1)"],
                type: "dashed",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: "{value}",
              color: "#000",
            },
          },
        ],
        series: [
          {
            name: this.$t('BatteryStatus.voltage'),
            type: "line",
            data: obj.power,
            yAxisIndex: 0,
          },
        ],
      };
      this.speedOption = option;
    },
    down() {
      if (domainName) {
        if (domainName.split(":")[0] !== "localhost") {
          let orgId = sessionStorage.getItem("roleData");
          let url = `https://${domainName}//v1/getExportExcel/uploadQueryBatteryPower?batteryNumber=${
            this.bindBattery
          }&startTime=${this.DataValue[0]}&endTime=${this.DataValue[1]}`;
          location.href = url;
        } else {
          let host = "localhost:8080";
          let url = `https://${host}//v1/getExportExcel/uploadQueryBatteryPower?batteryNumber=${
            this.bindBattery
          }&startTime=${this.DataValue[0]}&endTime=${this.DataValue[1]}`;
          location.href = url;
        }
      }
    },
    onSearch() {
      this.getSpeedAndWeightHis();
    },
    onClear() {
      this.DataValue = [];
      this.getSpeedAndWeightHis();
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
